import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/admin/users/$userId',
}).lazy(() => import('./$userId.index.lazy').then((d) => d.Route))
